import store from "@/store";
import { BASE } from "@/config";

// Компоненты и роуты Родителя
const ParentIndex = () => import("@/views/parents/Index.vue");
const MainPageView = () => import("@/views/parents/MainPageView.vue");
const NotificationsView = () => import("@/views/parents/NotificationsView.vue");
const PersonInfoView = () => import("@/views/parents/PersonInfoView.vue");
const PaymentView = () => import("@/views/parents/payment/Index.vue");
const BalanceHistoryView = () =>
  import("@/views/parents/BalanceHistoryView.vue");
const PassagesView = () => import("@/views/parents/PassagesView.vue");
const AgreementView = () => import("@/views/parents/AgreementView.vue");
const SupportView = () => import("@/views/parents/SupportView.vue");
const NoCardsForPupilView = () =>
  import("@/views/parents/forbidden/NoCardsForPupilView.vue");
const NoAccessView = () => import("@/views/parents/forbidden/NoAccessView.vue");
const ReportsView = () => import("@/views/parents/ReportsView.vue");

const checkTariffAccess = function (to, from, next) {
  const payer = store.state.child.payer;
  if (payer.current_tariff) {
    const checkOption = BASE.TARIFF.options.find(
      (o) => o.key === to.meta.checkTariff
    );
    if (checkOption && payer.current_tariff[checkOption.option]) {
      next();
    } else {
      next({ name: "Forbidden" });
    }
  } else {
    next({ name: "Forbidden" });
  }
};

export default {
  path: "/parents",
  component: ParentIndex,
  meta: { role: BASE.ROLES.PARENT },
  children: [
    {
      path: "",
      name: "MainPageParent",
      component: MainPageView,
      meta: { label: "Главная" },
    },
    {
      path: "person-info",
      name: "PersonInfo",
      component: PersonInfoView,
      meta: { label: "Личный кабинет" },
    },
    {
      path: "notifications",
      name: "NotificationsView",
      component: NotificationsView,
      meta: {
        label: "Сообщения",
        checkTariff: BASE.TARIFF.optionsKeys.INTERNAL,
      },
      beforeEnter: checkTariffAccess,
    },
    {
      path: "passages",
      name: "PassagesView",
      component: PassagesView,
      meta: {
        label: "Проходы ребенка",
        checkTariff: BASE.TARIFF.optionsKeys.PASSAGE_VIEW,
      },
      beforeEnter: checkTariffAccess,
    },
    {
      path: "payment",
      name: "PaymentView",
      component: PaymentView,
      meta: { label: "Оплата" },
    },
    {
      path: "balance-history",
      name: "BalanceHistoryView",
      component: BalanceHistoryView,
      meta: { label: "Движение денежных средств" },
    },
    {
      path: "reports",
      name: "ParentReportsView",
      component: ReportsView,
      meta: { label: "Отчеты" },
    },
    {
      path: "support",
      name: "SupportView",
      component: SupportView,
      meta: { label: "Тех поддержка" },
    },
    {
      path: "agreement",
      name: "AgreementView",
      component: AgreementView,
    },
    {
      path: "no-pupil-cards",
      name: "NoCardsForPupilView",
      component: NoCardsForPupilView,
    },
    {
      path: "no-access",
      name: "NoAccessView",
      component: NoAccessView,
    },
  ],
  beforeEnter(to, from, next) {
    const {
      state: { child },
    } = store;
    let redirectView = null;

    if (child.childId !== null && !child.loaded) {
      store
        .dispatch("GET_CHILD_DATA")
        .then(({ parent, cards }) => {
          if (!parent.is_school_connected && !parent.has_limited_access) {
            redirectView = "NoSchoolConnectedView";
          } else if (!cards.length) {
            redirectView = "NoCardsForPupilView";
          } else if (!parent.is_oferta_accepted) {
            redirectView = "AgreementView";
          } else if (!parent.has_access) {
            redirectView = "NoAccessView";
          }
        })
        .then(() => {
          if (redirectView) {
            return;
          }
          return store.dispatch("GET_PAYER_INFO");
        })
        .then(() => {
          if (redirectView) {
            next({ name: redirectView });
          } else {
            next();
          }
        })
        .catch(() => {
          next({ name: "Forbidden" });
        });
    } else {
      next();
      /*
      if (child.loaded) {
        next();
      } else {
        next({ name: "Forbidden" });
      }
      */
    }
  },
};
